import React, {useRef, useState} from 'react';
import {Button, Select, Space, Tag, Typography} from 'antd';
import {EyeOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';
import ENDPOINTS from '../../constants/endpoints';
import {formatPath, ROUTES} from '../../constants/PathRoutes';
import SearchTable from '../../components/admin/SearchTable';
import {dateFormat} from '../../utils/utils';

const STATUS_COLOR = {
    UNDER_REVIEW: 'orange',
    APPROVED: 'green',
    WITH_ISSUES: 'red',
};

const STATUS_OPTIONS = [
    {value: '', label: 'Todos'},
    {value: 'UNDER_REVIEW', label: 'Em Análise'},
    {value: 'APPROVED', label: 'Aprovado'},
    {value: 'WITH_ISSUES', label: 'Com Problemas'},
];

export default function AdminClientList() {
    const tableRef = useRef();
    const navigate = useNavigate();
    const [statusFilter, setStatusFilter] = useState('');

    const columns = [
        {title: 'ID', dataIndex: 'id', key: 'id', width: 60},
        {
            title: 'Nome',
            key: 'name',
            render: (_, r) => `${r.first_name} ${r.last_name}`,
        },
        {title: 'Email', dataIndex: 'email', key: 'email'},
        {title: 'CPF', dataIndex: 'cpf', key: 'cpf'},
        {title: 'Tipo', dataIndex: 'client_type_display', key: 'client_type'},
        {
            title: 'Status',
            dataIndex: 'status_display',
            key: 'status',
            render: (display, record) => (
                <Tag color={STATUS_COLOR[record.status] ?? 'default'}>{display ?? '-'}</Tag>
            ),
        },
        {
            title: 'Cadastro',
            dataIndex: 'date_joined',
            key: 'date_joined',
            render: (date) => dateFormat(date),
        },
        {
            title: 'Ações',
            key: 'actions',
            width: 80,
            render: (_, record) => (
                <Button
                    size="small"
                    icon={<EyeOutlined/>}
                    onClick={() => navigate(formatPath(ROUTES.ADMIN_CLIENT_DETAIL, {id: record.id}))}
                />
            ),
        },
    ];

    return (
        <>
            <Space style={{marginBottom: 16}} wrap>
                <Typography.Text strong>Status:</Typography.Text>
                <Select
                    value={statusFilter}
                    onChange={setStatusFilter}
                    options={STATUS_OPTIONS}
                    style={{width: 200}}
                />
            </Space>
            <SearchTable
                key={statusFilter}
                ref={tableRef}
                url={ENDPOINTS.STAFF_CLIENT_LIST}
                params={statusFilter ? {status: statusFilter} : {}}
                columns={columns}
                title="Clientes"
            />
        </>
    );
}
